import options from './CO2.component';


export default {
    selector: "dtEmulatorCo2",
    options
}